// Rótulos e cores dos status de documentos e assinaturas (back: Documento e Assinatura)
export const STATUS_DOCUMENTO = {
  pendente: { texto: 'Pendente', cor: 'secondary' },
  em_assinatura: { texto: 'Em assinatura', cor: 'warning' },
  assinado: { texto: 'Assinado', cor: 'success' },
  cancelado: { texto: 'Cancelado', cor: 'dark' },
}

export const STATUS_ASSINATURA = {
  pendente: { texto: 'Pendente', cor: 'secondary' },
  aguardando_autorizacao: { texto: 'Aguardando autorização', cor: 'warning' },
  assinando: { texto: 'Assinando', cor: 'info' },
  assinado: { texto: 'Assinado', cor: 'success' },
  erro: { texto: 'Erro', cor: 'danger' },
}

export function formatarData(valor) {
  if (!valor) return ''
  return new Date(valor).toLocaleString('pt-BR')
}

export function formatarCpf(cpf) {
  if (!cpf) return ''
  return String(cpf).replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4')
}

// Download autenticado (o link direto não levaria o header JWT)
export function baixarArquivo(url, nomePadrao) {
  return window.axios.get(url, { responseType: 'blob' }).then(resposta => {
    const disposicao = resposta.headers['content-disposition'] || ''
    const encontrado = /filename="?([^";]+)"?/.exec(disposicao)
    const link = document.createElement('a')
    link.href = URL.createObjectURL(resposta.data)
    link.download = encontrado ? decodeURIComponent(encontrado[1]) : nomePadrao
    document.body.appendChild(link)
    link.click()
    link.remove()
    setTimeout(() => URL.revokeObjectURL(link.href), 1000)
  })
}
